module.exports = __webpack_public_path__ + "img/compresor-1.fcfa9cbe.png";